// Polyfill Node.js globals required by @airgap/beacon-sdk
import { Buffer } from "buffer";
(globalThis as unknown as Record<string, unknown>).Buffer = Buffer;

// Suppress Beacon SDK's "metrics not found" unhandled promise rejection.
// This error comes from the SDK's internal IndexedDB metrics system and
// does not affect wallet functionality.
window.addEventListener("unhandledrejection", (event) => {
  const msg =
    event.reason instanceof Error
      ? event.reason.message
      : String(event.reason ?? "");
  if (msg.includes("metrics")) {
    event.preventDefault();
  }
});

// Preload Space Grotesk font for Canvas2D and drei <Text> usage
const fontPreloads = [
  { weight: "400", url: "/assets/fonts/SpaceGrotesk-Regular.ttf" },
  { weight: "500", url: "/assets/fonts/SpaceGrotesk-Medium.ttf" },
  { weight: "700", url: "/assets/fonts/SpaceGrotesk-Bold.ttf" },
];
for (const { weight, url } of fontPreloads) {
  const face = new FontFace("Space Grotesk", `url(${url})`, { weight });
  face.load().then((loaded) => document.fonts.add(loaded));
}

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { theme } from "./theme";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="top-right" />
      <App />
    </MantineProvider>
  </React.StrictMode>
);
